import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import theme from "./styles/theme";
import "./styles/global.css";

import { AuthProvider } from "./contexts/AuthContext";
import PrivateRoute from "./components/common/PrivateRoute";

import Login from "./pages/auth/Login";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetPasswordConfirm from "./pages/auth/ResetPasswordConfirm";
import AdminLayout from "./components/admin/AdminLayout";
import ColaboradorLayout from "./components/colaborador/ColaboradorLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminEventos from "./pages/admin/AdminEventos";
import AdminColaboradores from "./pages/admin/AdminColaboradores";
import AdminClientes from "./pages/admin/AdminClientes";
import AdminServicios from "./pages/admin/AdminServicios";
import AdminGastos from "./pages/admin/AdminGastos";
import AdminInsumos from "./pages/admin/AdminInsumos";
import UserProfile from "./pages/admin/UserProfile";
import AdminComisiones from "./pages/admin/AdminComisiones";
import Settings from "./pages/admin/Settings";
import Finanzas from "./pages/admin/Finanzas";
import ColaboradorDashboard from "./pages/colaborador/ColaboradorDashboard";
import ColaboradorMisEventos from "./pages/colaborador/ColaboradorMisEventos";
import ColaboradorFinanzas from "./pages/colaborador/ColaboradorFinanzas";
import ColaboradorPerfil from "./pages/colaborador/ColaboradorPerfil";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <ScrollToTop />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route
              path="/reset-password-confirm"
              element={<ResetPasswordConfirm />}
            />
            <Route path="/" element={<Navigate to="/login" replace />} />

            {/* Rutas de Administrador */}
            <Route
              path="/admin"
              element={
                <PrivateRoute requiredRole="administrador">
                  <AdminLayout />
                </PrivateRoute>
              }
            >
              <Route
                index
                element={<Navigate to="/admin/dashboard" replace />}
              />
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="eventos" element={<AdminEventos />} />
              <Route path="clientes" element={<AdminClientes />} />
              <Route path="colaboradores" element={<AdminColaboradores />} />
              <Route path="perfil" element={<UserProfile />} />
              <Route path="configuracion" element={<Settings />} />
              <Route path="servicios" element={<AdminServicios />} />
              <Route path="gastos" element={<AdminGastos />} />
              <Route path="insumos" element={<AdminInsumos />} />
              <Route path="finanzas" element={<Finanzas />} />
              <Route path="comisiones" element={<AdminComisiones />} />
            </Route>

            {/* Rutas de Colaborador */}
            <Route
              path="/colaborador"
              element={
                <PrivateRoute requiredRole="colaborador">
                  <ColaboradorLayout />
                </PrivateRoute>
              }
            >
              <Route
                index
                element={<Navigate to="/colaborador/dashboard" replace />}
              />
              <Route path="dashboard" element={<ColaboradorDashboard />} />
              <Route
                path="eventos"
                element={<ColaboradorMisEventos />}
              />
              <Route
                path="tareas"
                element={<div>Mis Tareas - En desarrollo</div>}
              />
              <Route path="finanzas" element={<ColaboradorFinanzas />} />
              <Route path="perfil" element={<ColaboradorPerfil />} />
            </Route>

            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
